import { SxProps, Theme } from '@mui/material';

export const textToSpeechStyles = {
  container: (theme: Theme) => ({
    display: 'inline-flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    padding: theme.spacing(2),
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[3],
    backgroundColor: theme.palette.background.paper,
  }) as SxProps<Theme>,

  title: (theme: Theme) => ({
    fontSize: '1.25rem',
    fontWeight: 500,
    color: theme.palette.text.primary,
  }) as SxProps<Theme>,

  button: (theme: Theme) => ({
    alignSelf: 'flex-start',
    fontSize: '1rem',
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.primary.dark}`,
      outlineOffset: '2px',
    },
  }) as SxProps<Theme>,
};
